import React from 'react';
import { Button, Form, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            indexNumber: '',
            studyProgramId: '',
            studyPrograms: []
        };
        this.onFilterData = this.onFilterData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        let courseImplementationId = localStorage.getItem('courseImplementation');
        let obj = {};
        axios.get(`professor/study-program-basics-and-departments-by-course/${courseImplementationId}`, { ...obj })
            .then(SPBAndDepartmentsRes => {
                const studyPrograms = SPBAndDepartmentsRes.data.studyProgramBasics.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: el.name
                }));
                this.setState({ studyPrograms });
            })
            .catch(err => {
                console.log('Failed to fetch study programs');
            });
    }

    onFilterData() {
        if (!this.state.studyProgramId && !this.state.firstName && !this.state.lastName && !this.state.indexNumber) {
            toast('Morate unijeti po čemu želite filtrirati podatke!');
        } else {
            this.props.onFilterData(
                this.state.studyProgramId,
                this.state.firstName,
                this.state.lastName,
                this.state.indexNumber
            );
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    render() {
        return (
            <Segment clearing>
                <br />
                <br />
                <Form>

                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Smjer (studijski program)</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite smjer (studijski program)"
                                value={this.state.studyProgramId}
                                onChange={this.handleInputChange}
                                name="studyProgramId"
                                options={this.state.studyPrograms}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        <Form.Field>
                            <label>Broj indexa</label>
                            <input
                                value={this.state.indexNumber}
                                onChange={(e) => this.setState({ indexNumber: e.target.value })}
                                name="indexNumber"
                                placeholder="Unesite broj indexa"
                            />
                        </Form.Field>

                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Ime</label>
                            <input
                                value={this.state.firstName}
                                onChange={(e) => this.setState({ firstName: e.target.value })}
                                name="firstName"
                                placeholder="Unesite ime"
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Prezime</label>
                            <input
                                value={this.state.lastName}
                                onChange={(e) => this.setState({ lastName: e.target.value })}
                                name="lastName"
                                placeholder="Unesite prezime"
                            />
                        </Form.Field>
                    </Form.Group>
                    <Button color="blue" floated="right" onClick={this.onFilterData}>Filtriraj
                    </Button>
                    <Button basic="true" color="blue" floated="right" onClick={this.props.filtersOff}>Odustani
                    </Button>
                </Form>
                <ToastContainer hideProgressBar />

            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/Filters.js